import React from 'react';
import PropTypes from 'prop-types';
import { REWARD_TYPE, getRewardTitle } from 'utils/rewards';
import iconDrawing from './icon-drawing.png';
import iconUber from './icon-uber.png';
import iconBattleSlots from './Icon_BattleSlots.svg';
import iconBonus from './icon-bonus.svg';
import iconFood from './icon-food.svg';
import iconFreePlay from './icon-freeplay.svg';
import iconShopping from './icon-shopping.svg';
import iconWindCreek from './icon-windcreek.svg';
import './RewardIcon.css';

const rewardIconMap = {
  [REWARD_TYPE.BONUS_POINTS]: iconBonus,
  [REWARD_TYPE.FOOD_CREDIT]: iconFood,
  [REWARD_TYPE.FREE_PLAY]: iconFreePlay,
  [REWARD_TYPE.SHOPPING_DOLLARS]: iconShopping,
  [REWARD_TYPE.HOTEL_STAY]: iconWindCreek,
  [REWARD_TYPE.DRAWING_TICKET]: iconWindCreek,
  [REWARD_TYPE.WSCORE]: iconShopping,
  [REWARD_TYPE.OF_NO_ACTION]: iconShopping,
  [REWARD_TYPE.BATTLE_SLOTS]: iconBattleSlots,
  [REWARD_TYPE.BATTLE_SLOTS_PRIZE_CATEGORY]: iconBattleSlots,
  [REWARD_TYPE.CASINO_DRAWINGS_CATEGORY]: iconDrawing,
  [REWARD_TYPE.UBER]: iconUber,
  [REWARD_TYPE.DEFAULT]: iconWindCreek
};

function RewardIcon({
  type = REWARD_TYPE.DEFAULT,
  size = 30,
  className,
  alt,
  url
}) {
  let icon = rewardIconMap[type] || rewardIconMap[REWARD_TYPE.DEFAULT];
  let setClass = `reward-icon-${type} size-${size}`;
  let setAlt = alt || alt === '' ? alt : getRewardTitle(type);

  if (typeof className !== 'undefined') {
    setClass = className;
  }

  return (
    <img
      className={setClass}
      alt={setAlt}
      aria-hidden={!setAlt}
      src={url || icon}
    />
  );
}

RewardIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.number
};

export default RewardIcon;
